// extracted by mini-css-extract-plugin
export var container = "index-module--container--Toc8-";
export var h4 = "index-module--h4--EzlYM";
export var moreButton = "index-module--moreButton--HgCOx";
export var p1 = "index-module--p1--sg1br";